<template>
  <el-popover
    width="100"
    popper-class="des-popper"
    trigger="hover"
    style="min-width: unset"
    :placement="placement"
  >
    <div class="des-info">
      <div class="item">
        <div class="label">名称</div>
        <div class="info">{{ value.name }}</div>
      </div>
      <div class="item">
        <div class="label">说明</div>
        <div class="info">{{ value.description }}</div>
      </div>
      <div class="item">
        <div class="label">参数</div>
        <div class="info">{{ value.params }}</div>
      </div>
      <div class="item">
        <div class="label">输出</div>
        <div class="info">{{ value.output }}</div>
      </div>
    </div>
    <div slot="reference">
      <i class="el-icon-info"></i>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: "des-popper",
  props: {
    value: Object,
    placement: {
      type: String,
      default: "right"
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.des-info {
  display: flex;
  flex-flow: column;
  .item {
    display: flex;
    .label {
      color: #606266;
      font-size: 12px;
      line-height: 24px;
      float: left;
      width: 40px;
    }
    .info {
      flex: 1;
      font-size: 12px;
      line-height: 24px;
      position: relative;
    }
  }
}
</style>

<style lang="scss">
.des-popper {
  min-width: unset;
}
.des-popper.el-popover {
  padding: 12px;
}
</style>
